import axios from 'axios';
function RegisterUserApi() {
    const registerUser = async (body, captcha) => {
        return axios.post(`/auth-service/services/v1/register?g-recaptcha-response=${captcha}`, body, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    };
    const validateCompanyCodeWithCaptcha = async (companyCode, captcha) => {
        return axios.get(`/auth-service/services/v1/register/public/validate-code/${companyCode}?g-recaptcha-response=${captcha}`);
    };
    const validateCompanyCodeWithToken = async (companyCode, token) => {
        return axios.get(`/auth-service/services/v1/register/secure/validate-code/${companyCode}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    };
    return { registerUser, validateCompanyCodeWithCaptcha, validateCompanyCodeWithToken };
}
export default RegisterUserApi;
